import React from 'react'
import arrow from "../assets/hero-section-arrow.png";
import heroLeft from "../assets/hero-section-left.png";
import heroPhone from "../assets/hero-phone.png";
import heroGrid from "../assets/hero-grid.png";


const Hero = () => {
  return (
    <div className='hero' id='hero'>
      
      <div className='hero-main'>
        <p className='hero-header'>I'm not a Product Designer; <br/> I'm a Reality Architect.</p>

        <p className='scroll-text'>Scroll Down</p>
      </div>
      
      <img src={arrow} className='hero-arrow' />

      <img src={heroLeft} className='hero-left'/>
      
      <div className='hero-right'>
        <img className='hero-phone' src={heroPhone}/>
        <img className='hero-grid' src={heroGrid} />
      </div>

    </div>
  )
}

export default Hero;
